import { ApolloClient, createHttpLink, FetchResult, InMemoryCache, makeVar, NormalizedCacheObject } from '@apollo/client';
import { setContext } from '@apollo/client/link/context';
// import { AnimationType, ListAchievement, ListQuestCompletion } from '../components/common/types';
// import { setUserId } from '../helpers/analytics';
import { cloudStorage } from '@tma.js/sdk';
// import AsyncStorage from '@react-native-async-storage/async-storage';
import { CachePersistor } from 'apollo3-cache-persist';
// import dayjs from 'dayjs';
// import * as SecureStore from 'expo-secure-store';
import { useCallback, useEffect, useState } from 'react';
import { isMockedEnvironment } from '../helpers/telegram';
import { CompleteQuestMutation, LoginMutation } from './generated/graphql';
import { ListQuestCompletion } from './types';

const uri = `${process.env.REACT_APP_API_URL}`;
const httpLink = createHttpLink({
    uri,
    fetch,
});

// export const showDayPlannerFlow = makeVar<dayjs.Dayjs | null>(null);
// export const showGoalCompletionFlow = makeVar(false);
export const focusModeFlowId = makeVar<{ questId: string; isRestore?: boolean } | null>(null);
// export const animationTypeData = makeVar<AnimationType[]>([]);
// export const completedAchievementData = makeVar<ListAchievement[]>([]);
// export const achievementSnackbarQuestData = makeVar<CreateQuestMutation | null>(null);
export const loginData = makeVar<LoginMutation['login'] | null>(null);
export const activeQuestCompletions = makeVar<Map<string, ListQuestCompletion>>(new Map());

export const addQuestCompletion = (completion: ListQuestCompletion) => {
    const active = activeQuestCompletions();
    active.set(completion.quest.id, completion);
    activeQuestCompletions(new Map(active));
};

export const addCompleteQuestResult = (result: FetchResult<CompleteQuestMutation>) => {
    const completeQuestResult = result.data?.completeQuest;
    if (!completeQuestResult) return;

    addQuestCompletion(completeQuestResult);
};

const authLink = setContext((_, { headers }) => {
    const token = loginData()?.value;
    return {
        headers: {
            ...headers,
            authorization: token,
        },
    };
});

const cache = new InMemoryCache();

export const useApolloClient = () => {
    const [client, setClient] = useState<ApolloClient<NormalizedCacheObject>>();
    const [persistor] = useState<CachePersistor<NormalizedCacheObject>>();
    const clearCache = useCallback(() => {
        if (!persistor) {
            return;
        }
        persistor.purge();
    }, [persistor]);

    useEffect(() => {
        async function init() {
            const cache = new InMemoryCache();
            // let newPersistor = new CachePersistor({
            //   cache,
            //   storage: new LocalStorageWrapper(window.localStorage),
            //   trigger: 'write',
            // });
            // await newPersistor.restore();
            // await newPersistor.purge();
            // setPersistor(newPersistor);

            if (!isMockedEnvironment() && cloudStorage.isSupported()) {
                const loginMutationData = await cloudStorage.getItem('login_data');
                if (loginMutationData) {
                    const parsedData = JSON.parse(loginMutationData);
                    loginData(parsedData);
                }
            }

            setClient(
                new ApolloClient({
                    link: authLink.concat(httpLink),
                    cache,
                }),
            );
        }

        init();
    }, []);

    return {
        client,
        clearCache,
    };
};

export const client = new ApolloClient<NormalizedCacheObject>({
    link: authLink.concat(httpLink),
    cache,
});
